import React from 'react';
import Modal from 'react-modal';



const ModalAlert = ({ isOpenModalAlert, handleCloseModalAlert, modalAlertMessage, modalAlertSubMessage }) => {

  return (
    <>
      <Modal isOpen={isOpenModalAlert} onRequestClose={handleCloseModalAlert} >
        <h2 className='font-bold text-lg text-[#54709e] mt-4'>{modalAlertMessage}</h2>
        <p className='text-sm text-[#54709e]'>{modalAlertSubMessage ? modalAlertSubMessage : ""}</p>
        <div className='float-right mt-4'>
          <button className='bg-blue-500 text-white py-1 px-8 rounded mr-2' onClick={handleCloseModalAlert}>Ok</button>
        </div>
      </Modal>
    </>
  );
}


export default ModalAlert;